import { render } from "./ClaimBar.vue?vue&type=template&id=6f91d71b&scoped=true"
import script from "./ClaimBar.vue?vue&type=script&lang=js"
export * from "./ClaimBar.vue?vue&type=script&lang=js"

import "./ClaimBar.vue?vue&type=style&index=0&id=6f91d71b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f91d71b"]])

export default __exports__